import React, { useState, useContext, useEffect } from "react";
import $ from "jquery";
import PsContext from "../../../context";
import { toast } from "react-hot-toast";
import {
  baseUrl,
  capitalizeFirst,
  groupByMultiple,
  upperCase,
  APP_TYPE,
  DB_POSTFIX,
} from "../../../utils";
import { Spin } from "antd";
import { ServiceUrl } from "../../../utils/serviceUrl";
import axios from "axios";
import { Button, Card } from "react-bootstrap";

const ApplicationList = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const [paymentLink, setPaymentLink] = useState([]);

  useEffect(() => {
    if (context.user.api_code) loadApplicationList();
  }, [context.user.api_code]);

  const loadApplicationList = () => {
    try {
      context.setLoader(true);
      var form = new FormData();
      form.append("i__apiCode", context.user.api_code);
      axios.post(ServiceUrl.UG.APPLIED_COURSES, form).then((res) => {
        if (res["data"].status == "1") {
          var d = groupByMultiple(res["data"].data, function (obj) {
            return [obj.uuid, obj.course_type];
          });
          setDataList(res["data"].data);
          setDataView(d);
        } else {
          toast.error(res["data"].message || "Error");
        }
        context.setLoader(false);
      });
    } catch (error) {
      context.setLoader(false);
    }
  };

  const listCourses = (items) => {
    let rv = [];
    items.map((item) =>
      rv.push(
        <div className="fw-600 fs-13 mb-1">
          {item.degreename} - {item.coursename}
        </div>,
      ),
    );
    return (
      <div className="ps-2 border-start border-primary border-2">{rv}</div>
    );
  };

  const repayClick = (item) => {
    if (!window.confirm("Do you want to repay?")) return;
    context.setLoader(true);
    const form = new FormData();
    form.append("i__apiCode", context.user.api_code);
    form.append("uuid", item.uuid);
    form.append("feegroupid", item.feegroupid);
    axios.post(ServiceUrl.UG.REPAY_LINK, form).then((res) => {
      if (res["data"].status == "1") {
        setPaymentLink(res["data"].data);

        //document.getElementById("redirect").submit();
      } else {
        toast.error(res["data"].message || "Error");
        context.setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (paymentLink && paymentLink.access_code) {
      if (paymentLink.type == "ccavenue") {
        document.getElementById("redirect").submit();
      } else if (paymentLink.type == "techprocess") {
        window.location = paymentLink.reqdata;
      }
    }
  }, [paymentLink]);

  const downloadFile = (item) => {
    context.setLoader(true);
    let sadb = "";
    if (APP_TYPE == "SAAS") {
      sadb = "?sadb=" + DB_POSTFIX;
    }
    var filePath =
      baseUrl +
      ServiceUrl.UG.APPLICATION_DOWNLOAD_LINKV2 +
      item.admission_year +
      "/" +
      item.uuid +
      "/" +
      item.application_code +
      sadb;

    var a = document.createElement("A");
    a.href = filePath;
    a.download = filePath.substr(filePath.lastIndexOf("/") + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    context.setLoader(false);
  };

  const trackMyOrderStatus = (course) => {
    try {
      context.setLoader(true);
      setLoader(true);
      var form = new FormData();
      form.append("i__apiCode", course.api_code);
      form.append("uuid", course.uuid);
      form.append("id", course.id);
      form.append("feegroupid", course.feegroupid);

      axios.post(ServiceUrl.UG.TRACK_MY_ORDER, form).then((res) => {
        if (res["data"].status == "1") {
          loadApplicationList();
        } else {
          toast.error(res["data"].message, "error");
        }
        setLoader(false);
        context.setLoader(false);
      });
    } catch (error) {
      setLoader(false);
      context.setLoader(false);
    }
  };

  if (dataView.length === 0) return null;

  return (
    <>
      <div className="neat-header mt-4">
        <span className="fw-700 text-uppercase fs-13 letter-spacing-1">
          Applied Applications
        </span>
      </div>
      <div className="neat-table-container">
        <Spin spinning={loader}>
          <div className="table-responsive">
            <table className="neat-table">
              <thead>
                <tr>
                  <th width="15%">Type</th>
                  <th width="15%">App.No</th>
                  <th width="45%">Course Details</th>
                  <th width="25%">Status & Actions</th>
                </tr>
              </thead>
              <tbody>
                {dataView.map((items, i) => {
                  let item = items[0];
                  return (
                    <tr key={i}>
                      <td className="fw-500">
                        {upperCase(item.course_type) == "SELF"
                          ? "Self Financed"
                          : "Aided"}
                      </td>
                      <td className="text-secondary">
                        {item.application_code}
                      </td>
                      <td>
                        <div className="course-list-small">
                          {listCourses(items)}
                        </div>
                        {item.rejected_by && (
                          <div className="status-badge status-rejected mt-1">
                            Rejected: {item.rejected_reason}
                          </div>
                        )}
                      </td>
                      <td align="center">
                        {item.fee_paid_status == "1" ? (
                          <div className="d-flex flex-column align-items-center gap-2">
                            {!item.rejected_by && (
                              <span className="status-badge status-paid">
                                <i className="fa-solid fa-check-circle me-1"></i>
                                PAID
                              </span>
                            )}
                            <Button
                              type="button"
                              variant="outline-success"
                              className="btn-neat"
                              onClick={(e) => downloadFile(item)}
                            >
                              <i className="fa-solid fa-download me-1"></i>
                              PDF
                            </Button>
                          </div>
                        ) : item.payment_method == "direct" &&
                          item.fee_paid_status == "0" ? (
                          <div className="text-center px-2">
                            <span className="fs-11 text-muted">
                              Community certificate verification in progress.
                              Wait 24h.
                            </span>
                          </div>
                        ) : (
                          <Button
                            type="button"
                            variant="primary"
                            className="btn-neat"
                            onClick={(e) => repayClick(item)}
                            style={{
                              background: "green",
                              border: "1px solid green",
                            }}
                          >
                            Pay ₹{item.total_fee}
                          </Button>
                        )}
                        {item.fee_paid_status == "0" &&
                          item.order_id != null &&
                          upperCase(item.fee_paid_response) !=
                            upperCase("Aborted") && (
                            <div className="mt-2">
                              <a
                                href="javascript:void(0)"
                                className="text-primary fs-11 fw-600"
                                onClick={(e) => trackMyOrderStatus(item)}
                              >
                                TRACK STATUS
                              </a>
                            </div>
                          )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Spin>
      </div>

      {paymentLink &&
        paymentLink.access_code &&
        paymentLink.type == "ccavenue" && (
          <form
            method="post"
            name="redirect"
            id="redirect"
            action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
          >
            <input
              type="hidden"
              name="encRequest"
              value={paymentLink.reqdata}
            />
            <input
              type="hidden"
              name="access_code"
              value={paymentLink.access_code}
            />
          </form>
        )}
    </>
  );
};

export default ApplicationList;
